module.exports = __webpack_public_path__ + "static/media/tribe_truck_start.14fc0277.png";